import React from 'react';

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-black z-[100] flex items-center justify-center" style={{ willChange: 'opacity' }}>
      <div className="relative">
        {/* Outer spinning ring */}
        <div className="w-32 h-32 rounded-full border-4 border-blue-600/20 animate-[spin_3s_linear_infinite]" style={{ willChange: 'transform' }}>
          {/* Inner spinning ring */}
          <div className="absolute inset-2 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent animate-[spin_1.5s_linear_infinite]" style={{ willChange: 'transform' }} />
          {/* Additional decorative ring */}
          <div className="absolute inset-4 rounded-full border-4 border-r-blue-600 border-l-transparent border-t-transparent border-b-transparent animate-[spin_2s_linear_infinite_reverse]" />
        </div>
        
        {/* ECHO text with glow effect */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative">
            <span className="absolute inset-0 text-3xl font-black text-blue-500/50 font-poppins blur-[8px] animate-pulse">
              ECHO
            </span>
            <span className="relative text-3xl font-black text-white font-poppins tracking-wider animate-pulse">
              ECHO
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}